import { useContext, useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { ToggleSelectionAction } from '../../../lib/context/SmartSendContextModels';
import SmartSendItem from './SmartSendItem';
import { P2GDivider } from '@parcel2go/core-ui';
import SmartSendGroupHeader from './SmartSendGroupHeader';
import SmartSendGroupFooter from './SmartSendGroupFooter';
import { useP2GInView } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';

import SmartSendItemContainer from './SmartSendItemContainer';

export interface SmartSendItemGroup {
  Title: string;
  Items: SmartSendItemApiModel[];
  IsGroupable: boolean;
  Hidden: boolean;
  States: string[];
}

interface props {
  group: SmartSendItemGroup;
  showTitle: boolean;
  isXs: boolean;
}

export default function SmartSendGroup(props: props) {
  const ctx = useContext(SmartSendContext);
  const all = useMemo(() => props.group.Items.every((x) => !!x.State?.selected), [props.group]);

  const [ref, inView] = useP2GInView({
    triggerOnce: true
  });

  const toggleSelectAll = () =>
    ctx.dispatch(
      new ToggleSelectionAction(
        props.group.Items.map((x) => x.Id),
        !all
      )
    );

  if (!inView) {
    return (
      <div ref={ref}>
        <P2GBox p={2} textAlign="center">
          ...
        </P2GBox>
      </div>
    );
  }

  if (props.showTitle) {
    return (
      <P2GBox mb={4}>
        <SmartSendGroupHeader group={props.group} isXs={props.isXs} all={all} toggleAll={toggleSelectAll} />
        <P2GBox mt={2} mb={2}>
          {props.group.Items.map((item) => (
            <SmartSendItemContainer key={`${item.Id}_${props.isXs}`}>
              <SmartSendItem item={item} isXs={props.isXs} />
            </SmartSendItemContainer>
          ))}
        </P2GBox>
        <SmartSendGroupFooter group={props.group} isXs={props.isXs}>
          <P2GDivider sx={(t) => ({ margin: t.spacing(2) })} />
        </SmartSendGroupFooter>
      </P2GBox>
    );
  }

  return props.group.Items.map((item) => (
    <P2GBox mb={1} key={`${item.Id}_${props.isXs}`}>
      <SmartSendItemContainer>
        <SmartSendItem item={item} isXs={props.isXs} />
      </SmartSendItemContainer>
    </P2GBox>
  ));
}
